import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  PaymentDashboardDetailStateType,
  PaymentDetailType,
} from 'features/Payment/@types/paymentDashboard'

export const SLICE_NAME = 'paymentDashboardDetail'

export const initialState: PaymentDashboardDetailStateType = {
  isLoading: [],
  paymentDetail: {
    payment_details: {
      payment_id: 0,
      payment_status: '',
      payment_method: '',
      payment_type: '',
      payment_amount: 0,
      payment_gateway: '',
      payment_gateway_status: '',
      payment_gateway_external_id: '',
      payment_gateway_reference_no: '',
      virtual_account_details: {
        biller_code: 0,
        va_number: 0,
      },
      ewallet_details: {
        ewallet_number: 0,
      },
      credit_card_details: {
        bank_name: '',
        provider: '',
      },
    },
    order_details: {
      order_parent_id: 0,
      order_children: [
        {
          order_id: 0,
          order_invoice: '',
          order_status: '',
          order_amount: 0,
          order_type: '',
        },
      ],
    },
    refund_details: {
      refund_status: false,
      refund_target: '',
      is_eligible_for_refund: false,
    },
    customer_details: {
      customer_id: 0,
      customer_name: ' ',
      customer_phone_number: '',
    },
    cs_details: {
      code: '',
      message: '',
      description: '',
      recommendation: '',
    },
  },
  modal: { mode: '' },
}

const paymentGatewayAdmin = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      if (payload) {
        state.isLoading.push(true)
      } else {
        state.isLoading.pop()
      }
    },
    setPaymentDetail: (state, { payload }: PayloadAction<PaymentDetailType>) => {
      const { payment_details } = payload
      state.paymentDetail = {
        ...payload,
        payment_details: {
          ...payment_details,
          payment_gateway_reference_no: payment_details.payment_gateway_reference_no
            ? payment_details.payment_gateway_reference_no
            : '',
        },
      }
    },
    setModal: (
      state,
      { payload }: PayloadAction<Partial<PaymentDashboardDetailStateType['modal']>>,
    ) => {
      state.modal = { ...state.modal, ...payload }
    },
  },
})

export default paymentGatewayAdmin.reducer
export const { reset, setIsLoading, setPaymentDetail, setModal } = paymentGatewayAdmin.actions
